module.exports = __webpack_public_path__ + "static/media/service3_card_fit.ed1c0238.png";